/** Тот же расклад, что util/installment.py: остаток копеек на последнем платеже. */
export const INSTALLMENT_PARTS = 3

export function isInstallmentPackage(item: { type?: string; installment_available?: boolean } | null | undefined): boolean {
    return item?.type === 'package_v2' && !!item.installment_available
}

export function splitInstallmentKopecks(total: number, parts = INSTALLMENT_PARTS): number[] {
    const safe = Math.max(0, Math.floor(total))
    const base = Math.floor(safe / parts)
    const amounts = Array.from({ length: parts - 1 }, () => base)
    amounts.push(safe - base * (parts - 1))
    return amounts
}

export function firstInstallmentKopecks(total: number): number {
    return splitInstallmentKopecks(total)[0]
}
